const callApi = (method, path, data, privateLink) => {
    return {
        type: privateLink ? 'API_CALL' : 'ADMIN_API_CALL',
        method,
        path,
        data
    }
}

export default callApi


// WEBPACK FOOTER //
// ./src/actions/apiActions.js